module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_engl_primaerlogo_pos.25cd05ce.png";